import React, { useEffect } from "react";
import Logo from "../Assets/img/logo.png";
import { Link, NavLink } from "react-router-dom";
import MobileMenuModal from "./MobileMenuModal";

const Header = () => {
  // Sticky Menu Area
  useEffect(() => {
    window.addEventListener("scroll", isSticky);
    return () => {
      window.removeEventListener("scroll", isSticky);
    };
  });

  /* Method that will fix header after a specific scrollable */
  const isSticky = (e) => {
    const header = document.querySelector(".header");
    const scrollTop = window.scrollY;
    scrollTop >= 2
      ? header.classList.add("sticky")
      : header.classList.remove("sticky");
  };

  return (
    <>
      {/* <!-- Main Header --> */}
      <header className="header">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-2 col-md-2 col-12">
              {/* <!-- Logo --> */}
              <div className="main-logo">
                <Link to="/home" className="logo-1" href="index.html">
                  <img src={Logo} alt="#" />
                </Link>
              </div>
              <div className="mobile-nav"></div>
            </div>
            <div className="col-lg-10 col-md-10 col-12">
              <div className="menu-area-top">
                <div className="main-menu">
                  <div className="navbar">
                    <div className="nav-item">
                      {/* <!-- Main Menu --> */}
                      <ul className="nav-menu mobile-menu navigation main-menu-inner">
                        <li>
                          <NavLink to="/home">Home</NavLink>
                        </li>
                        <li>
                          <NavLink to="/webfeature">Features</NavLink>
                        </li>
                        {/* <li>
                          <NavLink to="/addons">Addons</NavLink>
                        </li> */}
                        <li>
                          <NavLink to="/websubscription">
                            Package & Pricing
                          </NavLink>
                        </li>
                        <li>
                          <NavLink to="/aboutus">About us</NavLink>
                        </li>
                        {/* <li>
                          <NavLink to="/knowledgebase">Knowledge base</NavLink>
                        </li> */}
                        <li>
                          <NavLink to="/blog">Blog</NavLink>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                {/* <!-- Menu Right --> */}
                <div className="menu-right-btn nav-menu">
                  <li>
                    <Link to="/demorequest" className="theme-btn">
                      Demo Request
                    </Link>
                  </li>
                </div>
              </div>
            </div>
            <div className="col-auto">
              <MobileMenuModal />
            </div>
          </div>
        </div>
      </header>
      {/* <!-- End Main Header --> */}
    </>
  );
};

export default Header;
